<template>
  <b-container>
    <b-row>
      <b-col>
        <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
        <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
      </b-col>
    </b-row>
    <h1>Planos</h1>
    <b-row class="mb-3">
      <router-link :to="'/checklist/plans/save/'">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
    </b-row>
    <b-table
      ref="planTable"
      :busy.sync="isBusy"
      :items="tableProvider"
      :fields="fields"
      :filter="filter"
      :filter-debounce="600"
      :per-page="tablePerPage"
      :current-page="tableCurrentPage"
      striped
      hover
    >
      <template slot="thead-top" slot-scope="{ fields }">
        <b-tr>
          <b-th
            v-for="field in fields"
            :key="field.filterKey"
            class="vertical-align"
          >
            <div v-if="field.filterKey != 'actions'">
              <b-form-select
                v-if="field.filterKey == 'active'"
                v-model="filter[field.filterKey]"
                :options="optionsBoolean"
              />
              <b-form-select
                v-else-if="field.filterKey == 'typeOfPlan'"
                v-model="filter[field.filterKey]"
                :options="typeOfPlanOptions"
              />
              <b-form-select
                v-else-if="field.filterKey == 'typeOfContract'"
                v-model="filter[field.filterKey]"
                :options="typeOfContractOptions"
              />
              <b-form-input
                v-else
                v-model="filter[field.filterKey]"
                :placeholder="'Buscar por ' + field.label"
                class="idStyle"
              />
            </div>
          </b-th>
        </b-tr>
      </template>
      <template v-slot:cell(actions)="data">
        <router-link :to="'/checklist/plans/save/' + data.item.id">
          <b-button size="sm">{{ $t("geral.edit") }}</b-button>
        </router-link>
        <b-button
          v-if="data.item.active"
          variant="danger"
          class="ml-2"
          size="sm"
          @click="activateDeactivate(data.item.id)"
          >Desativar</b-button
        >
        <b-button
          v-else
          size="sm"
          @click="activateDeactivate(data.item.id)"
          class="ml-2"
          >Ativar</b-button
        >
      </template>
    </b-table>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </b-container>
</template>

<script>
export default {
  name: "PlanList",
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
  },
  data() {
    return {
      isBusy: false,
      alert: {
        error: "",
        success: "Plano alterado com sucesso",
      },
      tablePerPage: 510,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableRowCount: 0,
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          tdClass: "nowrapActions",
        },
        {
          key: "name",
          filterKey: "name",
          sortable: false,
          label: "Nome",
          tdClass: "nowrap",
        },
        {
          key: "value",
          filterKey: "value",
          sortable: false,
          label: "Valor",
          tdClass: "nowrap",
          formatter: (value, key, item) => {
            const stringValue = (value / 100).toFixed(2).toString();
            let double = stringValue
              .replace(".", ",")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return "R$ " + double;
          },
        },
        {
          key: "typeOfPlan",
          filterKey: "typeOfPlan",
          sortable: false,
          label: "Tipo de plano",
          tdClass: "nowrap",
          formatter: (value, key, item) => {
            if (value == 1) {
              return "Doação";
            } else if (value == 2) {
              return "Pagador";
            } else if (value == 3) {
              return "Interno";
            }
            return "Pela matriz";
          },
        },
        {
          key: "typeOfContract",
          filterKey: "typeOfContract",
          sortable: false,
          label: "Tipo de contrato",
          tdClass: "nowrap",
          formatter: (value, key, item) => {
            if (value == 1) {
              return "Mensal";
            }
            return "Anual";
          },
        },
        {
          key: "franchise",
          filterKey: "franchise",
          sortable: false,
          label: "Franquia de preenchimento",
          tdClass: "nowrap",
        },
        {
          key: "active",
          filterKey: "active",
          sortable: true,
          label: this.$t("geral.active"),
          thStyle: "width: 50px",
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      filter: {
        name: "",
        value: "",
        typeOfPlan: 0,
        typeOfContract: 0,
        franchise: "",
        active: true,
      },
      optionsBoolean: [
        { value: null, text: "Todos" },
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      typeOfPlanOptions: [],
      typeOfContractOptions: [
        { value: 0, text: "Todos" },
        { value: 1, text: "Mensal" },
        { value: 2, text: "Anual" },
      ],
    };
  },
  methods: {
    activateDeactivate(id) {
      this.$apiScheduler
        .post("/plan/activateDesactivate/" + id)
        .then((response) => {
          this.$refs.planTable.refresh();
          this.$forceUpdate();
          this.$refs.successFadeAlert.show();
        })
        .catch((error) => {
          this.$refs.fadeAlertDanger.show();
        });
    },
    getAllTypeOfPlan() {
      this.$apiScheduler
        .get("plan/getAlltypesOfPlan")
        .then((response) => {
          this.typeOfPlanOptions = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    tableProvider(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        active: ctx.filter.active,
        name: ctx.filter.name,
        value: ctx.filter.value,
        TypeOfContract: ctx.filter.typeOfContract,
        typeOfPlan: ctx.filter.typeOfPlan,
        franchise: ctx.filter.franchise,
      };

      this.$apiScheduler
        .post("/plan/getAllPaginated", apiParam)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });

      return null;
    },
  },
  mounted() {
    this.getAllTypeOfPlan();
  },
};
</script>

<style scoped>
/* Your component styles here */
</style>